import React from 'react';
import { DisplayPercent } from '..';

import './percentbar.css';

const PercentBar=({
  className='',
  name,
  percent
})=>{

  let finalClasses='percent-bar';
  if(className) {
    finalClasses+=' '+className;
  }

  const width = 100-((100-percent)/2);
  const style = {width: width+'%'}

  return <h4 style={style} className={finalClasses}>{name} 
    <DisplayPercent percent={percent} />
  </h4>
}

export default PercentBar;